module.exports = __webpack_public_path__ + "static/media/SEMS.db7cde8d.png";